// For palette reference, see https://www.figma.com/design/pBg6UxRuap2JjQwXWXbeUi/Global-%7C-Color-Palette?node-id=3406-28914&t=5m49kEonckCISSf5-0

interface Shades {
  [key: number | string]: string
}

interface PaletteProps {
  [key: string]: Shades
}

const palette: PaletteProps = {
  // Color without opacity, starting from 50 to 900
  blue: {
    50: '#E7F5FF',
    100: '#CDEAFE',
    200: '#92D1FF',
    300: '#4DB5FF',
    400: '#1199FA',
    500: '#0577DA',
    600: '#034481',
    700: '#002F61',
    800: '#00254F',
    900: '#001B3C',
  },

  green: {
    50: '#EFFBF8',
    100: '#E6FAF6',
    200: '#ACECE1',
    300: '#5DD1BF',
    400: '#2BC2AB',
    500: '#00A68C',
    600: '#109A85',
    700: '#017361',
    800: '#005747',
    900: '#00392F',
  },

  red: {
    50: '#FFF5F6',
    100: '#FFE9EC',
    200: '#FAACB6',
    300: '#ED7685',
    400: '#E35F70',
    500: '#E0485C',
    600: '#BF3648',
    700: '#A22636',
    800: '#801826',
    900: '#4D0E17',
  },

  yellow: {
    50: '#FEFAE7',
    100: '#FFF9D9',
    200: '#FFE591',
    300: '#FFD348',
    400: '#FFC70F',
    500: '#F5B700',
    600: '#D9A200',
    700: '#B38300',
    800: '#8C5900',
    900: '#593900',
  },

  purple: {
    50: '#FAF5FF',
    100: '#F2EBFB',
    200: '#DAC0FA',
    300: '#CD9EFF',
    400: '#C288F9',
    500: '#A855F7',
    600: '#8E3DDB',
    700: '#743BAB',
    800: '#60308C',
    900: '#441860',
  },

  orange: {
    50: '#FFF7E6',
    100: '#FFEED6',
    200: '#FFE1D1',
    300: '#FFC09E',
    400: '#FF9D7B',
    500: '#F76341',
    600: '#CA3E0A',
    700: '#A83E00',
    800: '#802F00',
    900: '#4D1C00',
  },

  grey: {
    50: '#F7F9FA',
    100: '#EAEEF4',
    200: '#C9CFDD',
    300: '#A0A9BE',
    400: '#7B849B',
    500: '#565F76',
    600: '#323C52',
    700: '#1F283C',
    800: '#151D32',
    900: '#0B1426',
  },

  // Color with opacity, starting from a5 to a90
  black: {
    a5: '#0000000D',
    a10: '#0000001A',
    a20: '#00000033',
    a30: '#0000004D',
    a40: '#00000066',
    a50: '#00000080',
    a60: '#00000099',
    a70: '#000000B2',
    a80: '#000000CC',
    a90: '#000000E5',
  },

  white: {
    a5: '#FFFFFF0D',
    a10: '#FFFFFF1A',
    a20: '#FFFFFF33',
    a30: '#FFFFFF4D',
    a40: '#FFFFFF66',
    a50: '#FFFFFF80',
    a60: '#FFFFFF99',
    a70: '#FFFFFFB2',
    a80: '#FFFFFFCC',
    a90: '#FFFFFFE5',
  },

  blue400: {
    a5: '#1199FA0D',
    a10: '#1199FA1A',
    a20: '#1199FA33',
    a30: '#1199FA4D',
    a40: '#1199FA66',
    a50: '#1199FA80',
    a60: '#1199FA99',
    a70: '#1199FAB2',
    a80: '#1199FACC',
    a90: '#1199FAE5',
  },

  green500: {
    a5: '#00A68C0D',
    a10: '#00A68C1A',
    a20: '#00A68C33',
    a30: 'undefined',
    a40: 'undefined',
    a50: '#00A68C80',
    a60: 'undefined',
    a70: 'undefined',
    a80: 'undefined',
    a90: 'undefined',
  },

  yellow500: {
    a5: 'undefined',
    a10: 'undefined',
    a20: '#F5B70033',
    a30: 'undefined',
    a40: 'undefined',
    a50: '#F5B70080',
    a60: 'undefined',
    a70: 'undefined',
    a80: 'undefined',
    a90: 'undefined',
  },

  red500: {
    a5: '#E0485C0D',
    a10: '#E0485C1A',
    a20: '#E0485C33',
    a30: 'undefined',
    a40: 'undefined',
    a50: '#E0485C80',
    a60: 'undefined',
    a70: 'undefined',
    a80: 'undefined',
    a90: 'undefined',
  },

  // Neutral Colors
  neutrals: {
    black: '#000000',
    white: '#FFFFFF',
  },
}

export default palette
